<form [formGroup]="form" (ngSubmit)="reset()" class="relative">

  <div *ngIf="error" class="alert alert-danger" role="alert">
    <a class="alert-link"> {{ error.message }} </a>
  </div>

  <div *ngIf="timeoutError" class="alert alert-danger" role="alert">
    <a class="alert-link" lang>auth.error</a>
  </div>

  <div *ngIf="!form.controls.invalid && success" class="alert alert-success" role="alert">
    <a href="#" class="alert-link" lang>auth.reset-completed</a>
  </div>

  <!-- Password -->
  <div class="form-group input-group">
    <input name="password" class="form-control form-input" placeholder="{{ 'signup.password-placeholder' | lang }}"
      formControlName="password" type="text" [ngClass]="{ 'is-invalid': submitted && form.controls.password.errors }">
  </div> <!-- form-group// -->

  <!-- Register button -->
  <div class="form-group">
    <button class="btn register" lang>auth.reset-password-button</button>
  </div> <!-- form-group// -->

  <!-- Spinner  -->

  <hs-spinner [show]="loading"></hs-spinner>

</form>